// ======================================================================
// File Name       : ContentDocumentContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import moment from 'moment';
import { Field, reduxForm, isInvalid, getFormValues, change } from 'redux-form';
import { connect } from 'react-redux';
import { Button, Form, Col } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import EnterpriseNoticeRegisterEditForm from '../../components/enterpriseNotification/EnterpriseNoticeRegisterEditForm';
import DialogConfirm from '../../components/DialogConfirm';
import * as EnterpriseAction from '../../actions/EnterpriseAction';
import * as MessageTemplate from '../../constants/MessageTemplate';
import {
  USE_DATE_RELEASE,
  PUBLIC_STATUS,
  RELEASE_TARGET_NOTICE_FOR_ENTERPRISE,
} from '../../constants/EnterpriseNoticeConstants';
import {
  VALIDATE_TYPE,
  RETURN_MAX_NUM,
  DEFAULT_DATE_FORMAT_SERVER,
  DEFAULT_DATE_FORMAT,
  DEFAULT_DATE_FROM,
  DEFAULT_DATE_TO,
  DEFAULT_DATE_TO_TEXT,
  DEFAULT_DATE_FROM_TEXT,
} from '../../constants/index';
import RenderField from '../../utils/ReduxFormUtils';
import Header from '../../components/Header';
import { getItemBoxName, parseDateForDetail, getDisplayPublicPeriod } from '../../utils/index';
import { ENTERPRISE_NOTIFICATION_LIST } from '../../constants/PathConstants';
import ModalWrapper from '../../components/modal/ModalWrapper';

class EnterpriseNoticeConfirmContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      noticeInfo: {
        noticeSecernId: null,
        noticeTitle: null,
        noticeContent: null,
        releaseTargetForEnterprise: 0,
        publicStatus: 0,
        publicDateFrom: null,
        publicDateTo: null,
        releasePeriod: USE_DATE_RELEASE.INDEFINITE_PERIOD,
      },
    };

    this.createParams = this.createParams.bind(this);
    this.getModalOptions = this.getModalOptions.bind(this);
    this.registerEnterpriseNotice = this.registerEnterpriseNotice.bind(this);
  }

  getModalOptions() {
    return {
      title: '',
      footerBtns: [
        { name: 'キャンセル', onClick: this.props.hideModal, variant: 'default' },
        {
          name: 'OK',
          onClick: this.registerEnterpriseNotice,
          variant: 'primary',
        },
      ],
    };
  }

  registerEnterpriseNotice() {
    const { formValues, history, isEdit } = this.props;
    const noticeInfo = this.createParams(formValues);
    this.props.dispatch(this.props.hideModal());
    if (isEdit) {
      this.props.dispatch(EnterpriseAction.editNoticeForEnterprise(noticeInfo)).then((error) => {
        if (!error) {
          history.push(ENTERPRISE_NOTIFICATION_LIST);
        }
      });
      return;
    }
    this.props.dispatch(EnterpriseAction.registerNoticeForEnterprise(noticeInfo)).then((error) => {
      if (!error) {
        history.push(ENTERPRISE_NOTIFICATION_LIST);
      }
    });
  }

  createParams(formValues) {
    const param = {};
    if (formValues) {
      formValues.noticeContent && (param.noticeContent = formValues.noticeContent);
      formValues.noticeTitle && (param.noticeTitle = formValues.noticeTitle);
      !isNaN(parseInt(formValues.releaseTargetForEnterprise, 10)) &&
        (param.releaseTargetForEnterprise = formValues.releaseTargetForEnterprise);
      formValues.publicDateFrom && (param.publicDateFrom = formValues.publicDateFrom);
      formValues.publicDateTo && (param.publicDateTo = formValues.publicDateTo);
      if (formValues.releasePeriod == USE_DATE_RELEASE.INDEFINITE_PERIOD) {
        param.publicDateFrom = '';
        param.publicDateTo = '';
      }
    }
    if (this.props.isEdit) {
      param.noticeForEnterpriseSecernId = formValues.noticeForEnterpriseSecernId;
    }
    return param;
  }

  render() {
    const { formValues } = this.props;
    let publicDateFromTemp = formValues.publicDateFrom;
    let publicDateToTemp = formValues.publicDateTo;
    if (formValues.releasePeriod == USE_DATE_RELEASE.INDEFINITE_PERIOD) {
      publicDateFromTemp = '';
      publicDateToTemp = '';
    }
    const publicPeriod = getDisplayPublicPeriod(publicDateFromTemp, publicDateToTemp);
    return (
      <div>
        <ModalWrapper
          temporaryHide={''}
          {...this.getModalOptions()}
          hideModal={this.props.hideModal}
          title="以下の内容で登録します"
          fixedHeight={false}
        >
          <Form className='form-horizontal'>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={4}>
                タイトル
              </Col>
              <Col as={Form.Label} sm={8}>
                {formValues.noticeTitle}
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={4}>
                お知らせ内容
              </Col>
              <Col as={Form.Label} sm={8}>
                {formValues.noticeContent}
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={4}>
                公開期間
              </Col>
              <Col as={Form.Label} sm={8} className="lable-value">
                {publicPeriod}
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={4}>
                公開範囲
              </Col>
              <Col as={Form.Label} sm={8}>
                {getItemBoxName(
                  RELEASE_TARGET_NOTICE_FOR_ENTERPRISE,
                  formValues.releaseTargetForEnterprise,
                )}
              </Col>
            </Form.Group>
          </Form>
        </ModalWrapper>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { noticeInfo } = state.enterpriseNotice;
  const formValues = ownProps.isEdit
    ? getFormValues('EnterpriseNoticeEdit')(state)
    : getFormValues('EnterpriseNoticeRegister')(state);
  return {
    ...{ noticeInfo },
    formValues,
  };
};

export default connect(mapStateToProps)(EnterpriseNoticeConfirmContainer);
